// src/components/FormDetails.js
import React, { useState, useEffect } from 'react';
import {
  Box,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetAllStates } from "../Common/API/Geography/action";
import { GetAllCityOfState } from '../Common/API/Geography/action';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
import STPDetails from './components/STPDetails';
import { useDispatch } from 'react-redux';
import { CustomButton } from '../../v2/MUI_custom_component';

const SelectedSTP = ({ firm = {} }) => {
  const  dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    buyerDetails = {},
    influencerTabSelected = false,
    selectedRole=''
  } = state;

  const [buyer, setBuyer] = useState({
    ...buyerDetails,
    delivery_district_id: buyerDetails?.district_id,
    delivery_Address_line1: firm?.company_address1,
    delivery_Address_line2: firm?.company_address2,
    delivery_Address_line3: firm?.company_address3,
    location_id: firm?.location_id,
    location_name: firm?.location_name,
  });
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const getStates = async () => {
    const { data, error, message } = await GetAllStates();

    if (!error) {
      setStates(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        })),
      );
    } else {
      Sentry.captureMessage('GetAllStates failed', {
        level: 'warning',
        tags: { module: 'inventory', flow: 'select_stp' },
        extra: { message },
      });
      return toast.error(message);
    }
  };

  const getDistricts = async (stateId) => {
    setDistricts([]);

    const { data, error, message } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    } else {
      Sentry.captureMessage('GetAllCityOfState failed', {
        level: 'warning',
        tags: { module: 'inventory', flow: 'select_stp' },
        extra: { stateId, message },
      });
      return toast.error(message);
    }
  };
  useEffect(() => {
    if (buyer.state_id) getDistricts(buyer.state_id);
  }, [buyer.state_id]);

  useEffect(() => {
    getStates();
  }, []);
  const [billInfo, setBillInfo] = useState();
  const [shipInfo, setshipInfo] = useState();
  useEffect(() => {
    if (buyer && Object.keys(buyer).length > 0) {
      setBillInfo({
        company_id: buyer?.company_id,
        company_name: buyer?.company_name,
        company_phone_no: buyer?.company_phone_no,
        address_line_1: buyer?.company_address1,
        address_line_2: buyer?.company_address2,
        address_line_3: buyer?.company_address3,
        company_pincode: buyer?.company_pincode,
        district_id: buyer?.district_id,
        state_id: buyer?.state_id,
        user_esi_id: buyer?.esi_info_with_operational_address?.[0]?.esi_info?.esi_id,
      });
      setshipInfo({
        company_id: buyer?.company_id,
        company_phone_no: buyer?.company_phone_no,
        address_line_1: buyer?.delivery_Address_line1,
        address_line_2: buyer?.delivery_Address_line2,
        address_line_3: buyer?.delivery_Address_line3,
        company_address: buyer?.delivery_Address_line1,
        company_pincode: buyer?.delivery_company_pincode,
        location_id: buyer?.delivery_location_id,
        location_name: buyer?.delivery_location_name,
        district_id: buyer?.delivery_district_id,
        state_id: buyer?.state_id,
      });
    }
  }, [buyer]);
  return (
    <>
    <Box sx={{ display: 'flex', justifyContent:'end', 
      p: { xs: 2, md: 0 },
      mr: { xs: 0, md: 4 },
      position: {xs: 'sticky', md: 'relative'}, 
      top: 0, 
      zIndex: 1000, 
      boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
      background: {xs: '#FAFAFA', md: 'transparent'},
      pb: 0,
    }}>
      <CustomButton
        variant='filled'
        color='primary'
        label={'Save'}
        sx={{ width: { xs: '100%', sm: 'auto' }}}
        onClick={() => {
          dispatch({
            type: 'SET_SELECTED_STP',
            data: buyer,
          });
          navigate('/inventory/checkout', {
            state: { 
              bill_info: billInfo,
              shipping_info: shipInfo,
              influencerTabSelected, 
              selectedRole
            }
          });
        }}
      />
    </Box>
    <Box sx={{ p: { xs: 2, md: 4 } }}>    
      <STPDetails
        firm={buyerDetails}
        selectedRole={selectedRole}
        setBuyerDetails={(e) => {
          setBuyer((prev) => ({
            ...prev,
            ...e,
          }));
        }}
        influencerTabSelected={influencerTabSelected}
      />
    </Box>
    </>
  );
};

export default SelectedSTP;
